export const regxCsvIgnoreWrappedInDoubleQuotes = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/

export const secretKey = "47813831-7686-488b-b6d5-c9b15d3fca7d";

export const dataProductsAccessRulesFileName = "data-products-access-rules.json";

export const customDataProductsAccessRulesFileName = "custom-data-products-access-rules.json";